module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/maestro-payment-card-d563fec7c0e133468ed50760ede1aec2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/maestro-payment-card.svg
// module id = rQRh
// module chunks = 24